/**
 * Created by RaoMeng on 2020/8/3
 * Desc: 信息服务费缴费
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Avatar } from 'antd'
import { Toast } from 'antd-mobile'
import { isObjEmpty, NoToChinese } from '../../utils/common'
import './RechargeInfoService.css'
import { fetchGet, fetchPost } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'

class RechargeInfoService extends Component {

  constructor () {
    super()

    this.state = {
      balance: '0',
      payment: '0',
      serviceDate: '',
      rechargeList: [],
    }
  }

  componentDidMount () {
    document.title = '信息服务费'

    Toast.loading('', 0)
    this.getServiceList()
  }

  componentWillUnmount () {
    Toast.hide()
  }

  render () {
    const { stu, stuPhoto, stuName, userInfo } = this.props
    const {
      balance,
      payment,
      serviceDate,
      rechargeList,
    } = this.state

    const rechargeItems = []
    rechargeList.forEach((rechargeObj, index) => {
      rechargeItems.push(<div className='service-content-layout1'>
        {/*payment=='1'?
        <div
          className='service-content-item'>
            <span
              className='service-content-item-text'>{rechargeObj.yearsMany}</span>
          <span
            className='service-content-item-text'>¥ {rechargeObj.amount}</span>
        </div> :*/}
        <div
          className='service-content-item'
          onClick={this.onRechargeClick.bind(this, index,
            rechargeObj.id)}>
            <span
              className='service-content-item-text'>{rechargeObj.yearsMany}</span>
          <span
            className='service-content-item-text'>¥ {rechargeObj.amount}</span>
        </div>
        {/*}*/}
      </div>)
    })

    return (
      <div id='info-service-root'>
        {/*头部-个人信息*/}
        <div className='info-service-head bg_light_green'>
          {isObjEmpty(stuPhoto)
            ? <Avatar size={64} icon='user'/>
            :
            <Avatar size={64} src={stuPhoto}/>}
            <div className="text_white span_16 margin_top_5">{stuName}</div>
          {/*<span className='head-name'
                style={{ fontSize: '14px' }}>{stuName}</span>
          <span className='head-name'>余额: {balance}元</span>*/}
        </div>
        <div
          className='head-stu-info-layout bg_light_green_transparent'>
          <div style={{ flex: 1 }}>入学日期:{stu.stuEnrollDate}</div>
          <div style={{ flex: 1 }}>年级:{userInfo.parent.student.stuGrade}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{payment=='1'?'已缴费':<span className="color_red">未缴费</span>}</div>
        </div>
        <div id='info-service-body'>
          {/*服务内容*/}
          <span className='service-content-title'>服务内容</span>
          {/*<span id='body-service-content'>{userInfo.parent.schoolContent}</span>*/}
          <span id='body-service-content'><div dangerouslySetInnerHTML={{ __html: userInfo.parent.schoolContent }} /></span>

          {/*服务说明*/}
          <span className='service-content-title'>服务说明</span>
          {/*<span id='body-service-content'>{userInfo.parent.schoolExplain}</span>*/}
          <span id='body-service-content'><div dangerouslySetInnerHTML={{ __html: userInfo.parent.schoolExplain }} /></span>

          {/*信息费列表*/}
          <span className='service-content-title'>信息费（元/年）</span>
          <div style={{ marginTop: '6px' }}>{rechargeItems}</div>
          <div
            style={{
              textAlign: 'center',
              margin: '40px 10px 20px 0px',
            }}>
            <span style={{
              color: 'blue',
              fontSize: '16px',
              borderBottom: '1px solid blue',
              fontWeight: '600',
            }}
                  onClick={this.toRechargeRecord}>历史缴费记录</span>
          </div>
        </div>
      </div>
    )
  }

  getServiceList = () => {
    const { studentId, schoolId, stuGradeId } = this.props
    let { rechargeList } = this.state
    rechargeList.length = 0
    fetchGet(API.INFO_SERVICE_SERVICE_LIST, {
      studentId,
      schoolId,
      gradeId: stuGradeId,
    }).then(response => {
      Toast.hide()
      if (response && response.data && response.data.rulesList &&
        response.data.rulesList.length > 0) {
        rechargeList = response.data.rulesList
      }
      this.setState({
        rechargeList,
        isLoading: false,
        serviceDate: response.data.allAsOfDate,
        balance: response.data.allMoney,
        payment: response.data.payment,
      }, () => {
        console.log(rechargeList)
      })
    }).catch(error => {
      Toast.hide()

      this.setState({
        rechargeList,
      })
      if (typeof error === 'string') {
        Toast.fail(error, 2)
      } else {
        Toast.fail('请求异常', 2)
      }
    })
  }

  onRechargeClick = (index, rid) => {
    this.wxPayRequest(rid)
  }

  toRechargeRecord = () => {
    this.props.history.push('/rechargeInfoServiceRecord')
  }

  wxPayRequest = (rid) => {
    const {schoolId} = this.props
    let err = ''
    Toast.loading('')
    let openId = ''
    if (typeof this.props.userOpenid == 'undefined' ||
      this.props.userOpenid == null || this.props.userOpenid == '') {
      Toast.fail('openId为空，请退出重新进入应用')
      return
    } else {
      openId = this.props.userOpenid
    }

    fetchPost(API.INFO_SERVICE_RECHARGE_ORDER, {
      openId: openId,
      rId: rid,
      studentId: this.props.userInfo.parent.student.stuId, //this.props.userInfo.parent.student.stuId
      parentId: this.props.userInfo.parent.parentId,   //this.props.userInfo.parent.parentId
      schoolUnify: this.props.userInfo.parent.schoolUnify,
      appId: this.props.userInfo.appId,
    }).then((response) => {
      Toast.hide()
      const data = response.data
      err = data
      if(err === undefined ){
        err=response.message;
      }
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady',
            this.onBridgeReady(data), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady',
            this.onBridgeReady(data))
          document.attachEvent('onWeixinJSBridgeReady',
            this.onBridgeReady(data))
        }
      } else {
        this.onBridgeReady(data)
      }
    }).catch((error) => {
      console.log('error:' + JSON.stringify(error))
      Toast.show('支付失败！' + err)
    })
  }

  onBridgeReady = (json) => {
    console.log('json:', json)
    const that = this
    window.WeixinJSBridge.invoke(
      'getBrandWCPayRequest', JSON.parse(json),
      function (res) {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          Toast.success('支付成功！')
          // that.props.history.push('/payResult/' + that.state.amount)
        } else {
          Toast.fail('支付失败！')
          // message.info("支付失败:" + res.err_msg)
          // that.setState({
          //     payInfo: json,
          //     payResult: "支付失败:" + JSON.stringify(res)
          // });
        }
      })
  }

}

let mapStateToProps = (state) => ({
  userInfo: { ...state.redUserInfo },
  studentId: state.redUserInfo.parent.student.stuId,
  stuGradeId: state.redUserInfo.parent.student.stuGradeId,
  schoolId: state.redUserInfo.user.schoolId,
  stu: state.redUserInfo.parent.student,
  userOpenid: state.redUserInfo.userOpenid,
  stuPhoto: state.redUserInfo.parent.student
    ? state.redUserInfo.parent.student.stuPhoto
    : '',
  stuName: state.redUserInfo.parent.student
    ? state.redUserInfo.parent.student.stuName
    : '',
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(RechargeInfoService)
